import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { useLanguage } from "../../Translations/LenguageContext";
import ErrorPage from "../../Components/ErrorPage";
import EditProjectModal from "./EditProjectModal";
import EmptyView from "../ViewComponents/EmptyView";
import LoadingCubes from "../ViewComponents/LoadingCubes";
import NoDataFoundMex from "../ViewComponents/NoDataFound";
import { IoOpenOutline } from "react-icons/io5";
import { PiDatabaseLight, PiEmpty } from "react-icons/pi";
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import DeleteProjectModal from "./DeleteProjectModal";

const MainProjects = ({ userData, no_session }) => {
    const { t } = useLanguage()
    const navigate = useNavigate();
    const user_id = sessionStorage.getItem("user_id");
    const [records, setRecords] = useState([]);
    const [filteredRecords, setFilteredRecords] = useState([]);
    const [activeFilter, setActiveFilter] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [updModal, setShowUpdModal] = useState(false);
    const [selectedRecordId, setSelectedRecordId] = useState(null);
    const [animateReset, setAnimateReset] = useState(false)
    const [projectName, setProjectName] = useState(null)

    const new_item_navigate = "/control_panel/projects/new_project"
    const no_data_mex = t.projects.no_data_found
    const title_empty = t.projects.new_data_title
    const subtitle_empty = t.projects.new_data_subtitle
    const item = "projects"


    const navigateToNewProject = () => {
        navigate(new_item_navigate);
    };

    const fetchRecords = async () => {
        setLoading(true)
        try {
            const response = await fetch("https://backend.erioon.com/get_projects", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ user_id }),
            });
            if (response.ok) {
                const result = await response.json();
                const projectsData = result.projects || {};

                const recordsArray = Object.values(projectsData);
                recordsArray.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
                setRecords(recordsArray);
                setFilteredRecords(recordsArray);
                setActiveFilter("newest")

            } else {
                setError(true);
            }
        } catch (err) {
            setLoading(false)
            setError(true);
        } finally {
            setTimeout(() => {
                setLoading(false)
            }, 800);
        }
    };

    useEffect(() => {
        if (user_id) {
            fetchRecords();
        } else {
            setError(true);
            setLoading(false);
        }
    }, [user_id]);

    const handleSort = (criteria) => {
        setActiveFilter(criteria);
        let sortedRecords = [...records];
        if (criteria === "alphabetical") {
            sortedRecords.sort((a, b) => a.project_name.localeCompare(b.project_name));
        } else if (criteria === "reverseAlphabetical") {
            sortedRecords.sort((a, b) => b.project_name.localeCompare(a.project_name));
        } else if (criteria === "newest") {
            sortedRecords.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        } else if (criteria === "oldest") {
            sortedRecords.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
        }
        setFilteredRecords(sortedRecords);
    };

    const resetFilters = () => {
        setActiveFilter("");
        setSearchQuery("")
        setAnimateReset(true)
        fetchRecords()
        setTimeout(() => {
            setAnimateReset(false)
        }, 1000);
        setFilteredRecords(records);
    };

    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        if (query.trim() === "") {
            setFilteredRecords(records);
            return;
        }

        const filtered = records.filter((record) => {
            return (
                record._id.toLowerCase().includes(query) ||
                record.project_name.toLowerCase().includes(query) ||
                record.project_description.toLowerCase().includes(query)
            );
        });

        setFilteredRecords(filtered);
    };

    const handleDeleteClick = (ProjID, projName) => {
        setSelectedRecordId(ProjID);
        setProjectName(projName)
        setShowDeleteModal(true);
    };

    const handleCloseModal = () => {
        setShowDeleteModal(false);
        setSelectedRecordId(null);
    };

    const handleEditClick = (ProjID) => {
        setSelectedRecordId(ProjID);
        setShowUpdModal(true);
    };

    const handleCloseUpd = () => {
        setShowUpdModal(false);
        setSelectedRecordId(null);
    }

    if (loading) {
        return <LoadingCubes />;
    } else if (error) {
        return <ErrorPage />;
    } else if (records.length === 0) {
        return <EmptyView navigate_link={new_item_navigate} title={title_empty} subtitle={subtitle_empty} item={item} />
    }

    return (
        <div className="main_view_container">

            <div className="header_main_view fade-in">
                <div className="header_title">
                    <p className="main_view_title">{t.projects.title}</p>
                    <p className="main_view_subtitle">{t.projects.subtitle}</p>
                    <button className="connect_email_btn" onClick={navigateToNewProject}>
                        <i className="fa-solid fa-plus"></i> {t.create}
                    </button>
                </div>
                {/* <img className="icon_img" src={item} alt="Organization icon" /> */}
            </div>
            <div className="filter_container fade-in">
                {records.length > 1 && (
                    <>
                        <button
                            className={`filter_btn ${activeFilter === "alphabetical" ? "clicked_filter" : ""}`}
                            onClick={() => handleSort("alphabetical")}
                        >
                            <i className="fa-solid fa-arrow-down-wide-short"></i> A-Z
                        </button>
                        <button
                            className={`filter_btn ${activeFilter === "reverseAlphabetical" ? "clicked_filter" : ""}`}
                            onClick={() => handleSort("reverseAlphabetical")}
                        >
                            <i className="fa-solid fa-arrow-up-short-wide"></i> Z-A
                        </button>
                        <button
                            className={`filter_btn ${activeFilter === "newest" ? "clicked_filter" : ""}`}
                            onClick={() => handleSort("newest")}
                        >
                            {t.from_newest}
                        </button>
                        <button
                            className={`filter_btn ${activeFilter === "oldest" ? "clicked_filter" : ""}`}
                            onClick={() => handleSort("oldest")}
                        >
                            {t.from_oldest}
                        </button>
                    </>
                )}
                <button
                    className={`filter_btn ${activeFilter === "reset" ? "clicked_filter" : ""}`}
                    onClick={resetFilters}
                >
                    <i className={`fa-solid fa-arrows-rotate ${animateReset ? "activated_animation" : ""}`}></i>
                </button>
                <div className="filter_input_cont">
                    <i className="fa-solid fa-magnifying-glass"></i>
                    <input
                        className="filter_input"
                        placeholder={t.search}
                        value={searchQuery}
                        onChange={handleSearch}
                    />
                </div>
            </div>
            <div className="organizations_cont fade-in">
                {filteredRecords.length === 0 ? (
                    <NoDataFoundMex message={no_data_mex} />
                ) : (
                    <>
                        {filteredRecords.map((record) => (
                            <div key={record._id} className={`${record.status == "deleting" ? "proj_item_deleting" : "proj_item"}`}>

                                {record.status == "deleting" ? (
                                    <>
                                    <p className="organization_title">{record.project_name}</p>
                                        <p className="organization_desc">{record.project_description}</p>
                                    </>
                                ) : (
                                    <>
                                        <p className="organization_title" onClick={() => navigate(`/project_panel/${record._id}/databases`)}>{record.project_name} <i><IoOpenOutline /></i></p>
                                        <p className="organization_desc">{record.project_description}</p>
                                    </>
                                )}

                                {record.status == "deleting" ? (
                                    <>
                                        <div className="organization_footer">
                                                <i className="failed_instance fa-solid fa-rotate"></i>

                                            <div className="organization_footer_deleting">
                                                <Dropdown className="dropdown_main">
                                            <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                                                <i className="fa-solid fa-ellipsis-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu className="custom-dropdown-menu">
                                                <Dropdown.Item
                                                    className="drop_down_item delete"
                                                    onClick={() => handleDeleteClick(record._id, record.project_name)}
                                                >
                                                    <i className="fa-solid fa-trash"></i> {t.delete}
                                                </Dropdown.Item>

                                            </Dropdown.Menu>
                                        </Dropdown>
                                                {/* <p>Deleting</p> */}
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className="organization_footer">
                                        <Dropdown className="dropdown_main">
                                            <Dropdown.Toggle className="custom-dropdown-toggle" as="div">
                                                <i className="fa-solid fa-ellipsis-vertical"></i>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu className="custom-dropdown-menu">
                                                <Dropdown.Item
                                                    className="drop_down_item"
                                                    onClick={() => handleEditClick(record._id)}
                                                >
                                                    <i className="fa-solid fa-pencil"></i> {t.edit} {record.project_name}
                                                </Dropdown.Item>
                                                <Dropdown.Item
                                                    className="drop_down_item delete"
                                                    onClick={() => handleDeleteClick(record._id, record.project_name)}
                                                >
                                                    <i className="fa-solid fa-trash"></i> {t.delete}
                                                </Dropdown.Item>

                                            </Dropdown.Menu>
                                        </Dropdown>
                                        <div>
                                            {record.databases && (
                                                <i><PiDatabaseLight /></i>
                                            )}

                                            {record.access && (
                                                <i><MdOutlineAdminPanelSettings /></i>
                                            )}

                                            {(!record.access && !record.databases) && (
                                                <i><PiEmpty /></i>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                        <div className="new_org_item" onClick={navigateToNewProject}>
                            <i className="fa-solid fa-plus"></i>
                        </div>
                    </>
                )}

            </div>

            <DeleteProjectModal
                show={showDeleteModal}
                handleClose={handleCloseModal}
                recordObject={records.find((record) => record._id === selectedRecordId)}
                fetchRecords={fetchRecords}
                endpoint={"delete_project"}
                record_type={projectName}
                message="This action CANNOT be undone. It will permanently delete the resource and all associated data."
            />

            <EditProjectModal
                show={updModal}
                handleClose={handleCloseUpd}
                recordObject={records.find((record) => record._id === selectedRecordId)}
                fetchRecords={fetchRecords}
            />
        </div>
    );
};

export default MainProjects;
